/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Sexe } from '@/enums';

// Code sexe attendu par l'API (M/F/I) à partir de la valeur du champ `sexe`
// posée par le composant EtatCivil (Sexe.Homme/Femme/Indetermine).
const SEXE_CODE_BY_SEXE: Record<string, string> = {
  [Sexe.Homme]: 'M',
  [Sexe.Femme]: 'F',
  [Sexe.Indetermine]: 'I',
};

const sexeToSexeCode = (sexe?: string | null): string | null =>
  (sexe && SEXE_CODE_BY_SEXE[sexe]) ?? null;

export default sexeToSexeCode;
